import { LockOpenRounded } from "@mui/icons-material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Grid, Typography } from "@mui/material";
import { useContext, useState } from "react";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import { FieldsSettingsContext } from "../../CustomNotificationPage";
import { field_IDs_mapping } from "../../fieldMapping";
import SettingsList from "../components/SettingsList";
import SettingsSection from "../components/SettingsSection";

export default function ControlsNotificationsSection() {
  const [fetchStatus, setFetchStatus] = useState(null);
  const colors = useColors();
  const getFieldsSettingsData = useContext(FieldsSettingsContext);

  const controlsFields = field_IDs_mapping.CONTROLS;

  const upperSettingsFieldIDs = [
    controlsFields.CONTROLS_AND_GAPS_HIGH,
    controlsFields.CONTROLS_AND_GAPS_MEDIUM,
    controlsFields.CONTROLS_AND_GAPS_LOW,
  ];

  const middleSettingsFieldIDs = [
    controlsFields.NEW_GAP,
    controlsFields.COMPLIANT_TURNED_GAP,
    controlsFields.GAP_ESCALATED,
    controlsFields.GAP_IMPROVED,
    controlsFields.SNOOZE_ENDED,
    controlsFields.CONTROL_ASSIGNMENT,
  ];

  const bottomSettingsFieldIDs = [
    controlsFields.GAP_TURNED_COMPLIANT,
    controlsFields.NEW_COMPLIANT,
  ];

  const upperSettingsData = getFieldsSettingsData(upperSettingsFieldIDs);
  const middleSettingsData = getFieldsSettingsData(middleSettingsFieldIDs);
  const bottomSettingsData = getFieldsSettingsData(bottomSettingsFieldIDs);

  return (
    <SettingsSection
      title="Control & Gaps"
      Icon={LockOpenRounded}
      fetchStatus={fetchStatus}
      setFetchStatus={setFetchStatus}
    >
      <Grid container direction="column" gap={0.5}>
        <Grid item>
          <Grid container direction="row" gap={1} alignItems="center">
            <Typography variant="subtitle2" color={colors.text_primary}>
              Gap Severity
            </Typography>
            <CustomToolTip
              title={
                "This selection affects the notification settings for the events listed below"
              }
              style={{ maxWidth: "500px" }}
            >
              <HelpOutlineIcon
                sx={{
                  color: colors.text_secondary,
                  width: "12px",
                  height: "12px",
                }}
              />
            </CustomToolTip>
          </Grid>
        </Grid>
        <Grid item mb={1}>
          <SettingsList
            settingsData={upperSettingsData}
            setFetchStatus={setFetchStatus}
          />
        </Grid>
        <Grid item>
          <SettingsList
            settingsData={middleSettingsData}
            setFetchStatus={setFetchStatus}
          />
        </Grid>
        <Grid item> &nbsp;</Grid>
        <Grid item>
          <SettingsList
            settingsData={bottomSettingsData}
            setFetchStatus={setFetchStatus}
          />
        </Grid>
      </Grid>
    </SettingsSection>
  );
}
